import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert } from 'react-bootstrap';
import { TRIP_CLAIMS_REFUSED, tripClaimsLink } from '../../Utils/tripClaims';

/**
 * Shows the API's refusal to complete a booking while trip claims wait
 * ("2 trip claims waiting for review: 1 receipt, 1 overtime"), with the way
 * to the Trip claims page narrowed to that booking. Listens for the
 * refusal markAsCompleted announces, so it works wherever "Mark Completed"
 * is offered.
 */
function TripClaimsRefusalAlert() {
  const [refusal, setRefusal] = useState(null);

  useEffect(() => {
    const onRefused = (event) => setRefusal(event.detail || null);
    window.addEventListener(TRIP_CLAIMS_REFUSED, onRefused);
    return () => window.removeEventListener(TRIP_CLAIMS_REFUSED, onRefused);
  }, []);

  if (!refusal) return null;

  return (
    <Alert variant="warning" dismissible onClose={() => setRefusal(null)} data-testid="trip-claims-refusal">
      <div className="fw-semibold">
        {`Can't mark ${refusal.reference || 'this booking'} completed yet`}
      </div>
      <div className="small">{refusal.message}</div>
      <Link to={tripClaimsLink(refusal.bookingId)} className="small fw-semibold">
        Review them on Trip Claims
        <i className="fa fa-arrow-right ms-1" />
      </Link>
    </Alert>
  );
}

export default TripClaimsRefusalAlert;
